module.exports = __webpack_public_path__ + "img/assets/cookie@2x.png";